import { createFileRoute, redirect } from '@tanstack/react-router'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { z } from 'zod'
import { useAuth } from '../auth'
import { NotSubscribedResult } from '../components/not-subscribed-result'
import { INDEX_WEBHOOK } from '../user/permission'
import { WebhookShow } from '../webhook/components/webhook-show'
import { useTitle } from '../hooks/use-title'
import { searchQuery } from '../zod/pagination'

export const Route = createFileRoute('/_auth/_main/webhooks/$webhookId')({
    beforeLoad: ({ context }) => {
        if (!context.auth.can(INDEX_WEBHOOK)) {
            throw redirect({
                to: '/dashboard',
            })
        }
    },
    validateSearch: z.object({
        query: searchQuery.optional(),
    }),
    component: ShowWebhook,
})

function ShowWebhook() {
    const { t } = useTranslation()
    const { hasSubscription } = useAuth()
    const { webhookId } = Route.useParams()
    const search = Route.useSearch()

    useTitle(t('Webhooks'))

    if (!hasSubscription) {
        return <NotSubscribedResult />
    }

    return (
        <WebhookShow
            webhookId={webhookId}
            search={search}
        />
    )
}
